import React from "react";

interface RadioGroupProps {
  label?: string;
  name: string;
  options: {
    label: string;
    value: string;
  }[];
  value?: string;
  onChange: (value: string) => void;
  error?: string;
}

export function RadioGroup({
  label,
  name,
  options,
  value,
  onChange,
  error,
}: RadioGroupProps) {
  return (
    <div className="max-w-full">
      {label && (
        <label className="block text-[#A9A9A9] mb-1 ml-1 font-medium">
          {label}
        </label>
      )}

      <div className="flex flex-wrap gap-x-6 gap-y-3 p-1">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center gap-2 cursor-pointer whitespace-nowrap text-sm font-medium text-white"
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              className={`w-[18px] h-[18px] shrink-0 cursor-pointer border-[2px] border-[#333333] rounded-full ${
                value === option.value
                ? "appearance-auto accent-white"
                : "appearance-none bg-black"
                }`}
            />
            {option.label}
          </label>
        ))}
      </div>

      {error && (
        <p className="text-red-500 text-sm font-medium mt-1">{error}</p>
      )}
    </div>
  );
}
